import React from 'react';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle.ts';
import BillingPaymentHistory from './BillingPaymentHistory.jsx';
import BillingPaymentMethods from './BillingPaymentMethods.tsx';
import { BillingSubscriptions } from './BillingSubscriptions.tsx';
import BillingSummarySection from './BillingSummarySection.jsx';

interface BillingOverviewProps {}

export const BillingOverview: React.FC<BillingOverviewProps> = () => {

  useSetModalTitle('Billing');

  return (
    <>
      <BillingSummarySection />
      <BillingSubscriptions />
      <BillingPaymentMethods />
      <BillingPaymentHistory />
    </>
  );
}

